import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import Resize from 'react-resize-detector';
import useSavedScroll from "../hooks/useSavedScroll";
var defaultTheme = {
  overflowTop: 'overflow-top',
  overflowBottom: 'overflow-bottom',
  overflowLeft: 'overflow-left',
  overflowRight: 'overflow-right'
};

var ScrollContainer = function ScrollContainer(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      height = _ref.height,
      scrollPositionKey = _ref.scrollPositionKey,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? defaultTheme : _ref$theme,
      props = _objectWithoutProperties(_ref, ["children", "className", "height", "scrollPositionKey", "theme"]);

  var _useState = useState({
    overflowTop: false,
    overflowBottom: false,
    overflowLeft: false,
    overflowRight: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      overflow = _useState2[0],
      setOverflow = _useState2[1];

  var container = useRef(null);
  useSavedScroll(container, scrollPositionKey);

  function detectOverflow() {
    if (container.current) {
      var _container$current = container.current,
          clientHeight = _container$current.clientHeight,
          clientWidth = _container$current.clientWidth,
          scrollHeight = _container$current.scrollHeight,
          scrollLeft = _container$current.scrollLeft,
          scrollTop = _container$current.scrollTop,
          scrollWidth = _container$current.scrollWidth;
      setOverflow({
        overflowTop: scrollTop > 0,
        overflowBottom: scrollHeight - scrollTop > clientHeight,
        overflowLeft: scrollLeft > 0,
        overflowRight: scrollWidth - scrollLeft > clientWidth
      });
    }
  }

  var overflowTop = overflow.overflowTop,
      overflowBottom = overflow.overflowBottom,
      overflowLeft = overflow.overflowLeft,
      overflowRight = overflow.overflowRight;
  var classNames = classnames(className, 'scroll-container', 'position-relative', (_classnames = {}, _defineProperty(_classnames, theme.overflowTop, overflowTop), _defineProperty(_classnames, theme.overflowBottom, overflowBottom), _defineProperty(_classnames, theme.overflowLeft, overflowLeft), _defineProperty(_classnames, theme.overflowRight, overflowRight), _classnames));
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: "jsx-184956421" + " " + (props && props.className != null && props.className || classNames || "")
  }), /*#__PURE__*/React.createElement("div", {
    ref: container,
    style: {
      maxHeight: height,
      overflow: 'auto'
    },
    onScroll: function onScroll() {
      return detectOverflow();
    },
    className: "jsx-184956421"
  }, children), /*#__PURE__*/React.createElement(Resize, {
    handleWidth: true,
    handleHeight: true,
    onResize: function onResize() {
      return detectOverflow();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "jsx-184956421" + " " + 'container-shadow'
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "184956421"
  }, ".scroll-container.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:none;content:\"\";display:block;top:0px;left:0px;bottom:0px;right:0px;pointer-events:none;position:absolute;z-index:990;}.scroll-container.overflow-right.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-left.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-left.overflow-right.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:8px 0 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-bottom.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 -8px 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-bottom.overflow-right.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 -8px 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-bottom.overflow-left.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 -8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-bottom.overflow-left.overflow-right.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 -8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-right.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-left.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-left.overflow-right.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-bottom.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,0 -8px 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-bottom.overflow-right.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-bottom.overflow-left.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,0 -8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-bottom.overflow-left.overflow-right.jsx-184956421 .container-shadow.jsx-184956421{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset,0 -8px 8px -8px rgba(0,0,0,0.25) inset;}"));
};

ScrollContainer.displayName = "ScrollContainer";
ScrollContainer.displayName = 'ScrollContainer';
export default ScrollContainer;